import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CustomerPage from "../pages/customer/page";
import PartnerPage from "../pages/partner/page";
import AboutPage from "../pages/about/page";
import ApplyPage from "../pages/apply/page";
import CustomerPrivacy from "../pages/legal/CustomerPrivacy";
import CustomerTerms from "../pages/legal/CustomerTerms";
import PartnerPrivacy from "../pages/legal/PartnerPrivacy";
import PartnerTerms from "../pages/legal/PartnerTerms";
import RefundPolicy from "../pages/legal/RefundPolicy";

import BookServicesPage from "../pages/book-services/page";
import CustomerSupportPage from "../pages/customer-support/page";
import FAQsPage from "../pages/faqs/page";
import PartnerSupportPage from "../pages/partner-support/page";
import EarningsGuidePage from "../pages/earnings-guide/page";
import CareersPage from '../pages/careers/page';
import PressPage from '../pages/press/page';
import AdsPage from '../pages/ads/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/customer",
    element: <CustomerPage />,
  },
  {
    path: "/partner",
    element: <PartnerPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/apply",
    element: <ApplyPage />,
  },
  {
    path: "/customer-privacy",
    element: <CustomerPrivacy />,
  },
  {
    path: "/customer-terms",
    element: <CustomerTerms />,
  },
  {
    path: "/partner-privacy",
    element: <PartnerPrivacy />,
  },
  {
    path: "/partner-terms",
    element: <PartnerTerms />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicy />,
  },
  {
    path: "/book-services",
    element: <BookServicesPage />,
  },
  {
    path: "/customer-support",
    element: <CustomerSupportPage />,
  },
  {
    path: "/faqs",
    element: <FAQsPage />,
  },
  {
    path: "/partner-support",
    element: <PartnerSupportPage />,
  },
  {
    path: "/earnings-guide",
    element: <EarningsGuidePage />,
  },
  {
    path: "/careers",
    Component: CareersPage
  },
  {
    path: "/press",
    Component: PressPage
  },
  {
    path: "/ads",
    Component: AdsPage
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;